import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'lib-search-form-buttons',
  templateUrl: './search-form-buttons.component.html',
  styleUrls: ['./search-form-buttons.component.scss']
})
export class SearchFormButtonsComponent implements OnInit {
  @Input() typeSearch: string = 'submit';
  @Input() disabled: boolean = false;
  @Input() containerClass: string = '';
  @Output() search: EventEmitter<any> = new EventEmitter();
  @Output() clear: EventEmitter<any> = new EventEmitter();
  @Input() textSearch: string = 'Buscar';
  @Input() showIconSearch: boolean = true;
  @Input() searchButtonClass: string = '';
  @Input() clearButtonClass: string = '';

  constructor() { }

  ngOnInit() {
  }

  handleSearch = () => {
    if (this.typeSearch == 'button') {
      this.search.emit();
    }
  }

  handleClear = () => {
    this.clear.emit();
  }

}
